module.exports = __webpack_public_path__ + "static/img/Murphy-Reid.d7fb614.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Murphy-Reid.jpg
// module id = nM4T
// module chunks = 0